import {WAR_PHASE_STAGES} from "../../constants/phases";

export const getWarPhaseStageName = (phase) => {
  const phaseNames = {
    [WAR_PHASE_STAGES.RECRUITMENT]: 'Найм',
    [WAR_PHASE_STAGES.MOVEMENT]: 'Перемещение',
    [WAR_PHASE_STAGES.ABILITIES]: 'Способности',
    [WAR_PHASE_STAGES.SHOOTING]: 'Стрельба',
    [WAR_PHASE_STAGES.COMBAT]: 'Ближний бой',
    [WAR_PHASE_STAGES.MANEUVER]: 'Манёвр',
  };
  return phaseNames[phase] || phase;
};